// extracted by mini-css-extract-plugin
module.exports = {"footer":"V46pFw"};